import React, { useEffect, useState } from 'react';
import '../Chat/Chat.css';
import { FaFacebook } from "react-icons/fa";
import { FaFacebookF, FaWhatsapp, FaInstagram, FaLinkedinIn, FaArrowUp } from 'react-icons/fa';

const Chat = () => {
  const [showArrow, setShowArrow] = useState(false);

  const handleScroll = () => {
    setShowArrow(window.scrollY > window.innerHeight);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="chat-vertical-bar">
        
        <a href="https://api.whatsapp.com/send/?phone=%2B919220347091&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
         <a href="https://www.facebook.com/people/%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80-Var-Event-Conference/61576009690738/#" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
        <a href="https://www.instagram.com/shriivarevent/?igsh=bG9mb2o3b3gxZHh2#" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://www.linkedin.com/in/%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80-var-events-and-conferences-5a902a363/?originalSubdomain=in" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
      </div>

      {showArrow && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </div>
      )}
    </>
  );
};

export default Chat;
